import script from "./MKpi.vue?vue&type=script&setup=true&lang=js"
export * from "./MKpi.vue?vue&type=script&setup=true&lang=js"

import "./MKpi.vue?vue&type=style&index=0&id=2783644e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2783644e"]])

export default __exports__